import { jsxs as r, jsx as e } from "@emotion/react/jsx-runtime";
import { memo as s } from "react";
import { PageHeaderContainer as f, TitleAndActionsRow as g, TitleContainer as h, StyledIcon as C, ActionsContainer as w, StyledSeparator as x, DescriptionContainer as P } from "./PageHeader.styled.js";
import { Actions as S } from "./subComponents/Actions/Actions.js";
import { Description as A } from "./subComponents/Description/Description.js";
import { Title as j } from "./subComponents/Title/Title.js";
import { AvatarPanel as y } from "../AvatarPanel/index.js";
import { NotificationPanel as H } from "../NotificationPanel/index.js";
const T = s(({
  title: m,
  description: i,
  actions: o,
  displayNotification: t = !1,
  displayAvatar: n = !1,
  titleIcon: a,
  onClickTitleIcon: c = () => {
  },
  user: l,
  avatarMenuItems: p = []
}) => {
  const d = o && o?.length > 0 && (t || n);
  return /* @__PURE__ */ r(f, { children: [
    /* @__PURE__ */ r(g, { direction: "row", justifyContent: "space-between", children: [
      /* @__PURE__ */ r(h, { direction: "row", alignItems: "center", children: [
        a && /* @__PURE__ */ e(C, { icon: a, iconSize: "24px", onClick: c }),
        /* @__PURE__ */ e(j, { title: m })
      ] }),
      /* @__PURE__ */ r(w, { gap: "8px", direction: "row", alignItems: "center", children: [
        /* @__PURE__ */ e(S, { actions: o }),
        d && /* @__PURE__ */ e(x, { direction: "vertical" }),
        t && /* @__PURE__ */ e(H, {}),
        n && /* @__PURE__ */ e(y, { user: l, items: p })
      ] })
    ] }),
    i && /* @__PURE__ */ e(P, { children: /* @__PURE__ */ e(A, { description: i }) })
  ] });
});
T.displayName = "PageHeader";
export {
  T as PageHeader
};
